<bootstrap-popup [id]="id" [displaySubject]="displaySubject" 
	[title]="'Personne Avertie'" [modalSize]="'modal-lg'" [windowCloseButton]="true">

	<pannel [title]="'Intervenant'" [expandable]="true">
		<ng-container [ngTemplateOutlet]="blocSignatairesOuIntervenants"></ng-container>
	</pannel>
        
	<div class="row">
		<div class="col-md-12">
			<div class="form-group text-center">
				<button type="button" class="btn btn-success" style="margin-right: 10px" (click)="onCloseRequested()">
					Fermer
				</button>
				<button type="button" class="btn btn-primary" style="margin-right: 6px" title = "Sauvegarder" (click)="saveIntervenants()" >
					Sauvegarder
				</button>
			</div>
		</div>
	</div>
</bootstrap-popup>

<signataire-dialog [id]="'gererIntervenantsInListPa'" [initCommands]="gererIntervenantsCommands" (signatairesSelected)="onIntervenantsSelected($event)"></signataire-dialog>

<ng-template #blocSignatairesOuIntervenants>
        <div style="display: inline-flex">
            <button type="button" class="btn btn-primary" (click)="openDialogIntervenants()">
            	Ajouter Intervenant
            </button>
			<select class="form-control entreprise-filter" [(ngModel)]="selectedEntrepriseForIntervenantDialog">
			    <option [ngValue]="null"></option>
			    <option *ngFor="let entreprise of entreprises" [ngValue]="entreprise">{{entreprise.nom}}</option>
			</select>
        </div>
        
		<div class="form-group row entreprises" *ngFor="let entry of getSignatairesByEntreprise() | keyvalue">
		    <div class="col-sm-12 block-ent">
		
		        <!-- Entreprise -->
		        <div class="col-sm-12 checkbox-inline nom-entreprise">
		            <span class="col-sm-4 nom-prenom">{{ entry.value[0]?.nomEntreprise }}</span>
		        </div>
		
		        <!-- Intervenants -->
		        <div
		            class="col-sm-12 checkbox-inline intervenant"*ngFor="let signataire of entry.value; let index = index">
		            <span class="col-sm-4 nom-prenom">{{ signataire.nom }} {{ signataire.prenom }}</span>
		        </div>
		    </div>
		</div>
</ng-template>